import * as React from "react";
import {NumericFormat, NumericFormatProps} from "react-number-format";
import TextField from "@mui/material/TextField";
import {FC, useState} from "react";
import _ from "lodash";
import { useTranslation } from "react-i18next";

interface CustomProps {
  prefix?: string;
  onChange: (event: { target: { name: string; value: string } }) => void;
  name: string;
}

const NumericFormatCustom = React.forwardRef<NumericFormatProps, CustomProps>(
    function NumericFormatCustom(props, ref) {
      const {onChange, prefix, ...other} = props;

      return (
          <NumericFormat
              {...other}
              getInputRef={ref}
              onValueChange={(values) => {
                onChange({
                  target: {
                    name: props.name,
                    value: values.value,
                  },
                });
              }}
              thousandSeparator
              valueIsNumericString
              prefix={prefix}
          />
      );
    }
);

interface FormattedInputsProps {
  value: number;
  error: string;
  regex: string;
  onValueChange: (value: number) => void;
  id?: string;
  variant?: 'standard' | 'outlined';
  placeholder?: string;
  label?: string;
  size?: 'small' | 'medium';
  disabled?: boolean;
  prefix?: string;
  sx?: any;
}

const FaNumericInput = ({
                          value,
                          error,
                          onValueChange,
                          id,
                          label,
                          placeholder,
                          variant,
                          size = 'medium',
                          disabled = false,
                          regex,
                          prefix,
                          sx
                        }: FormattedInputsProps) => {
  const [errorMessage, setErrorMessage] = useState<string>("");
  const [showError, setShowError] = useState<boolean>(false);
  const { i18n } = useTranslation()
  const [numValue, setNumValue] = useState<string>(value.toString())

  React.useEffect(() => setNumValue(String(value)), [value])

  // React.useEffect(() => {
  //     setErrorMessage(showError ? error : "");
  // }, [showError]);

  return (
      <TextField
          id={id ?? ''}
          sx={sx ? sx : {}}
          label={label}
          size={size}
          placeholder={placeholder}
          value={i18n.language === 'de' ? numValue.replace(/\./g, ',') : numValue.replace(/,/g, '.') || 0}
          disabled={disabled}
          prefix={prefix}
          onChange={(event) => {
            let newValue = _.get(event.target, 'value', '').replace(/,/g, '.');
            if (newValue.length <= 0) {
              newValue = '0';
            }
            setNumValue(_.get(event.target, 'value', '0'))
            if (new RegExp(regex).test(newValue)) {
              onValueChange(Number(newValue));
              setErrorMessage('')
            } else {
              setErrorMessage(error)
            }
          }}
          InputProps={{
            // inputComponent: NumericFormatCustom as any,
          }}
          FormHelperTextProps={{
            style: {
              fontSize: 12,
              width: '100%',
              color: '#ba000d'
            },
          }}
          variant={variant ?? 'standard'}
          helperText={errorMessage}
      />
  );
};

FaNumericInput.displayName = 'NumericInput';
export default FaNumericInput;
